import styled from 'styled-components';

export const TableBody = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-template-rows: repeat(auto-fit, max-content);
  grid-gap: 8px;
  grid-column-gap: 16px;

  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media print {
    grid-column-gap: 8px;
  }
`;
